// extracted by mini-css-extract-plugin
module.exports = {"personal-data-text":"styles_personal-data-text__pG8Fe"};